<template>
  <div class="">
    <zt-modal :active="activeModal" @close="closeModal" max-width="32rem" :z-index="49">
      <div class="modal-content-wrapper p-8">
        <h3 class="text-lg font-bold text-gray-700 mb-4">
          {{ $t('message.LincensesHistorySummaryComponent.labels.licenseDaysByPeriod') }}
        </h3>

        <div v-if="loading" class="flex justify-center items-center py-10">
          <div class="text-zt-base text-zt-dark-400">
            {{ $t('message.loginComponent.login.loadingtext') }}
          </div>
        </div>

        <div v-else-if="error" class="flex justify-start items-center p-4 mb-2 bg-certs-error">
          <zt-icon name="exclamation-circle-solid" class="info-icon mr-2" />
          <p class="text-zt-base font-normal self-center">
            {{ error }}
          </p>
        </div>

        <div v-else-if="holidayDetails">
          <p v-if="holidayDetails.observations" class="text-zt-base text-zt-dark-500 mb-4">
            <span class="font-bold text-gray-700">{{ $t('message.LincensesApprovalPendingComponent.labels.observations') }}:</span> {{ holidayDetails.observations }}
          </p>
          <div
            v-for="(period, index) in holidayDetails.periodDetails"
            :key="index"
            class="mb-2"
          >
            <div v-for="(type, typeIndex) in period.types" :key="typeIndex" class="period-row">
              <span v-if="typeIndex === 0" class="font-bold text-gray-700 period-year">{{ period.year }}:</span>
              <span v-else class="period-year"></span>
              <span class="text-zt-base text-zt-dark-500">{{ type.description }}: {{ type.quantity }} {{ getDayTypeText(type.quantity) }}</span>
            </div>
          </div>
        </div>

        <div v-else class="text-zt-base text-zt-dark-400 py-10 text-center">
            {{ $t('message.inicioComponent.notResults') }}
        </div>

      </div>
    </zt-modal>
  </div>
</template>

<script>
import SichernPeople from '@/apiClient/SichernIntegration'

export default {
  props: {
    activeModal: {
      type: Boolean,
      default: false
    },
    licenceId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      sichernPeople: null,
      loading: false,
      error: '',
      holidayDetails: null
    }
  },
  created() {
    this.sichernPeople = new SichernPeople()
  },
  watch: {
    activeModal(newVal) {
      if (newVal && this.licenceId) {
        this.viewHolidayDetailsVP(this.licenceId)
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    getDayTypeText(quantity) {
      var singularMap = {
        'corridos': 'corrido',
        'hábiles': 'hábil',
        'úteis': 'útil'
      }
      var desc = this.holidayDetails && this.holidayDetails.holidayTypeDescription
      var dayWord = quantity === 1
        ? this.$t('message.LincensesApprovalPendingComponent.labels.day')
        : this.$t('message.LincensesApprovalPendingComponent.labels.days')
      if (!desc) return dayWord
      var lower = desc.toLowerCase()
      var typeText = quantity === 1 ? (singularMap[lower] || lower) : lower
      return dayWord + ' ' + typeText
    },
    viewHolidayDetailsVP(id) {
      this.loading = true
      this.error = ''
      this.holidayDetails = null
      this.sichernPeople.getHolidayDetailsVP(id)
        .then(response => {
          this.holidayDetails = response.data.data
        })
        .catch(() => {
          this.error = this.$t('message.errorReference.SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_ERROR')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.buttonPrimaryProperties {
  color: white !important;
}

::v-deep .zt-modal-button-close {
  color: black !important;
}

.zt-icon-exclamation-circle-solid {
  font-size: x-large;
  color: red;
}

.bg-certs-error > p {
  color: #ec1101 !important;
  opacity: 1 !important;
}

.bg-certs-error {
  background: #ffe2de 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #ffe2de;
}

.modal-content-wrapper {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.period-row {
  display: flex;
  align-items: baseline;
}

.period-year {
  min-width: 50px;
  flex-shrink: 0;
}
</style>
